'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.baseInfo = void 0;
var _md = _interopRequireDefault(require('md5'));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
var baseInfo = {
    getUserInfo: function () {
        return grounds.getUserInfo();
    },
    getDeviceInfo: function () {
        return grounds.getDeviceInfo();
    },
    getShowMode: function () {
        return grounds.getShowMode();
    },
    getAppName: function () {
        return grounds.getDeviceInfo().getProid();
    },
    getGuid: function () {
        return grounds.getUserInfo().getGuid();
    },
    getTokenAndTimestamp: function (e) {
        var t = grounds.getUserInfo().getGuid();
        console.log(t);
        var n = Date.now() + '', o = n.substr(0, 3) + '', r = n.substr(4, 6) + '', u = o + e + '_' + t + r;
        return {
            token: (0, _md.default)((0, _md.default)((0, _md.default)(u))),
            time: o + '' + r
        };
    }
};
exports.baseInfo = baseInfo;